import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeNgComponent } from '../../utils/ng.utils';

export type HtmlTitleProps = {
    title?: string;
    name?: string;
    type?: string;
    action?: string;
};

HtmlTitle.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    action: PropTypes.string,
};

export function HtmlTitle({ title, name, type, action }: HtmlTitleProps) {
    useEffect(() => {
        const parts = [...(title ? [title] : [name, action, type]), 'Zoral Automation Platform']
            .map((s) => s && s.trim())
            .filter((s) => !!s);

        window.document.title = parts.join(' - ');
    }, [title, name, action, type]);

    return null;
}

makeNgComponent('htmlTitle', HtmlTitle);
